<template>
    <v-card>
        <v-card-title>All Permissions</v-card-title>

        <v-divider />

        <v-card-text>

            <v-data-table class="mt-4 elevation-1" :headers="headers" :items="permissionItems" item-key="key" sort-by="group"  hide-default-footer  :items-per-page="-1" light v-if="showTable">

                <template v-slot:item.group_name="{ item }">
                    <v-icon class="mr-2">{{ item.group ? 'mdi-account-group' : 'mdi-account' }}</v-icon>
                    <span>{{ item.group_name }}</span>
                </template>
                <template v-slot:item.perm_action="{ item }">
                    <span class="action" :class="{deny: item.perm_action == 'DENY'}">{{ item.perm_action }}</span>
                </template>

            </v-data-table>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">ok</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'AllPermissions',
    props: ['userPermissions', 'userId'],
    components: {

    },
    data: () => ({
        userGroups: [],
        activeUserGroups: [],
        permissionItems: [],
        headers: [
            {text: 'Group', align: 'start', filterable: true, groupable: false, value: 'group_name'},
            {text: 'Perm Function', filterable: true, groupable: false, value: 'perm_function'},
            {text: 'Perm Qualifier', filterable: true, groupable: false, value: 'perm_qualifier'},
            {text: 'Perm Action', filterable: true, groupable: false, value: 'perm_action'},
        ],
        showTable: false
    }),

    computed: {
    },

    methods: {
        getUserGroupsList: function() {
            let userId = this.$props.userId;
            let route = (TELSA.apiHost + "usergroups/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.userGroups = result.user_groups_list;
                for(let ug of this.userGroups) {
                    if(ug.group_members.includes(userId)) {
                        this.activeUserGroups.push(ug);
                    }
                }
                let promises = [];
                for(let aug of this.activeUserGroups) {
                    let route = (TELSA.apiHost + "usergroups/permissions");
                    promises.push(this.$http.post(route, {args: {userGroup: aug}}).then(response => {
                        let result = response.body;
                        aug.permissions = result;
                    }));
                }
                return Promise.all(promises).then(res => {
                    for(let p of this.$props.userPermissions) {
                        this.permissionItems.push({
                            group: false,
                            group_name: 'User Permissions',
                            key: `user_perms_${p.perm_function}`,
                            perm_function: p.perm_function,
                            perm_qualifier: p.perm_qualifier,
                            perm_action: p.perm_action
                        });
                    }
                    for(let aug of this.activeUserGroups) {
                        for(let p of aug.permissions) {
                            this.permissionItems.push({
                                group: true,
                                group_name: aug.group_name,
                                key: `${aug.group_name}_${p.perm_function}`,
                                perm_function: p.perm_function,
                                perm_qualifier: p.perm_qualifier,
                                perm_action: p.perm_action
                            }); 
                        }
                    }
                    this.showTable = true;
                    TELSA.loading(false);
                });
            });
        }
    },

    mounted() {
        this.getUserGroupsList();
    }

  
};
</script>

<style scoped>

    .action {
        color: #4caf50;
    }
    .deny {
        color: #ff5252;
        font-weight: bold;
    }

</style>
